/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationTitleService } from 'app/layout/services/application-title.service';
import { OrderSearchListService } from 'app/modules/order/order-search/order-search/services/order-search-list.service';

@Component({
	selector: 'customer-details',
	templateUrl: './customer-details.component.html',
	styleUrls: ['./customer-details.component.scss'],
	standalone: false,
})
export class CustomerDetailsComponent {
	basketCustomerId: number = 1;
	parentCollapsed = false;
	isOrganiserUser = false;

	customerId: number;
	constructor(private service: OrderSearchListService, private route: ActivatedRoute, appTitleService: ApplicationTitleService) {
		appTitleService.setTitle('Customer Details');
		this.customerId = +route.snapshot.params['id'];
	}

	onFilterChanged(filters: any) {
		this.service.setFilters(filters);
	}
	onShowFiltersChanged() {
		this.parentCollapsed = !this.parentCollapsed;
	}
	setIsOrganiserUser(isOrganiserUser: boolean) {
		this.isOrganiserUser = isOrganiserUser;
	}
}
